<template>
  <div v-if="!disabled" class="upload-document-file-wrapper">
    <div class="file-upload-header">
      <b-img
        id="upload-file-icon"
        class="upload-file-icon"
        :src="getUploadFileIconPath"
        alt="Upload File"
      />
      <div>
        <label for="document-file-upload" class="raft-b4 font-size-100">{{
          label
        }}</label>
      </div>
    </div>
    <b-form-file
      :ref="fileRefId"
      :value="document"
      v-model="selectedFile"
      :label="label"
      :id="fieldName"
      :name="fieldName"
      :multiple="allowMultiple"
      :accept="EntityFormHelper.getAllowedFileMimeTypes(fieldConfig).join(', ')"
      @input="filesAdded"
      :file-name-formatter="fileNameFormat"
      :placeholder="''"
    >
      <template slot="file-name" />
    </b-form-file>
    <RaftFileUploadRow
      v-for="(attFile, ind) in fileList"
      :key="ind"
      :attached-file="attFile"
      @fileRemove="removeFileFromList"
      :disable-removal="disableRemovals"
    />

    <!--     <p>
      <em>{{ description }}</em>
    </p> -->
    <p v-if="!suppressReplaceWarning">
      If a new file is uploaded, the existing file will be replaced when you
      submit this form.
    </p>
  </div>
</template>

<script>
import EntityFormHelper from "../../lib/EntityFormHelper";
import PathMapper from "../../lib/PathMapper";
import RaftFileUploadRow from "./RaftFileUploadRow.vue";

export default {
  name: "RaftFileUpload",
  components: { RaftFileUploadRow },
  data() {
    return {
      EntityFormHelper: EntityFormHelper,
      PathMapper: PathMapper,
      selectedFile: null,
      fileList: [],
      fileNameList: [],
    };
  },
  props: {
    required: { type: Boolean, default: false },
    fieldName: { type: String, required: true },
    label: { type: String, default: "" },
    description: { type: String, default: "" },
    fieldConfig: { type: Object, required: true },
    document: { type: [String, Object], default: null },
    suppressReplaceWarning: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disableRemovals: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
  },
  computed: {
    getUploadFileIconPath: function () {
      return PathMapper.getIconAssetPath("upload.png", this.$isB4);
    },
    formGroupClasses: function () {
      let classes = "form-group";
      if (this.required) {
        classes += " required";
      }
      return classes;
    },
    allowMultiple: function () {
      return this.fieldConfig.field_storage.cardinality === -1 || this.multiple;
    },
    fileRefId: function () {
      return "raft-file-" + this.fieldName;
    },
  },
  methods: {
    filesAdded(files) {
      if (Array.isArray(files)) {
        files.forEach((newFile) => {
          if (!this.fileNameList.includes(newFile.name)) {
            this.fileList.push(newFile);
            this.fileNameList.push(newFile.name);
          }
        });
      } else {
        this.fileList.push(files);
      }
      const value = { field_name: this.fieldName, field_value: this.fileList };
      this.$emit("fileUploaded", value);
      this.selectedFile = null;
      this.clearFileInput();
    },
    fileNameFormat() {
      return "";
    },
    removeFileFromList(file, fileName) {
      this.fileList = this.fileList.filter((item) => {
        if (item.name !== fileName) {
          return item;
        }
      });
      this.fileNameList = this.fileNameList.filter((item) => item !== fileName);
      const value = { field_name: this.fieldName, field_value: this.fileList };
      this.$emit("fileUploaded", value);
      this.selectedFile = null;
      this.clearFileInput();
    },
    clearFileInput() {
      // This clears the bootstrap portion of the file upload handling.
      // This is needed to allow for files to be re-uploaded if they're removed.
      this.$refs[this.fileRefId].reset();
    },
  },
};
</script>

<style scoped>
div.upload-document-file-wrapper {
  background: #f8f8fb;
  border: 1px dashed #0432ff;
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
}

div.upload-document-file-wrapper label {
  font-weight: 600;
}

.file-upload-header {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

:deep(.form-file-text) {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.5rem;
  width: 100%;
}

:deep(.custom-file) {
  width: 100%;
}
</style>
